import React, { useEffect, useState } from "react";
import { FaUserPlus, FaPlus } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const AddGuestPreview = () => {
    const { t } = useTranslation();
    return (
        <div className="p-4 bg-white w-full max-w-2xl mx-auto rounded-xl">
            <h2 className="text-2xl font-semibold text-center mb-5 flex items-center justify-center">
                <FaUserPlus className="mr-2 text-gray-700" /> {t('addGuest')}
            </h2>
            <p className="text-gray-600 mb-7">{t('addGuestDescription')}</p>
            <form className="flex flex-col space-y-7 mb-10">
                <div className="flex flex-col">
                    <label className="font-semibold flex items-center mb-1">{t('fullNameLabel')} *</label>
                    <input type="text" className="inputWedding !bg-white !pl-4 !text-gray-900 !opacity-100 disabled:!bg-white disabled:!text-gray-900 disabled:!opacity-100" disabled placeholder={t('fullNamePlaceholder')} />
                </div>
                <div className="relative mb-5">
                    <label className="font-semibold flex items-center mb-1">{t('genderLabel')} *</label>
                    <input type="text" className="inputWedding !bg-white !pl-4 !text-gray-900 !opacity-100 disabled:!bg-white disabled:!text-gray-900 disabled:!opacity-100" disabled placeholder={t('genderPlaceholder')} />
                </div>
                <button disabled className="submitButton w-full opacity-50 cursor-not-allowed">
                    {t('addGuest')}
                </button>
            </form>
        </div>
    );
};

const AddTablePreview = () => {
    const { t } = useTranslation();
    return (
        <div className="p-4 bg-white w-full max-w-2xl mx-auto rounded-xl">
            <h2 className="text-2xl font-semibold text-center mb-5 flex items-center justify-center">
                <FaPlus className="mr-2 text-gray-700" /> {t('addTable')}
            </h2>
            <p className="text-gray-600 mb-7">{t('addTableDescription')}</p>
            <form className="flex flex-col space-y-7 mb-10">
                <div className="flex flex-col">
                    <label className="font-semibold flex items-center mb-1">{t('tableNameLabel')} *</label>
                    <input type="text" className="inputWedding !bg-white !pl-4 !text-gray-900 !opacity-100 disabled:!bg-white disabled:!text-gray-900 disabled:!opacity-100" disabled placeholder={t('tableNamePlaceholder')} />
                </div>
                <div className="flex flex-col">
                    <label className="font-semibold flex items-center mb-1">{t('seatCountLabel')} *</label>
                    <input type="text" className="inputWedding !bg-white !pl-4 !text-gray-900 !opacity-100 disabled:!bg-white disabled:!text-gray-900 disabled:!opacity-100" disabled placeholder={t('seatCountPlaceholder')} />
                </div>
                <button disabled className="submitButton w-full opacity-50 cursor-not-allowed">
                    {t('addTable')}
                </button>
            </form>
        </div>
    );
};

const forms = [AddGuestPreview, AddTablePreview];

const FormPreview = () => {
    const [CurrentForm, setCurrentForm] = useState(() => forms[0]);

    useEffect(() => {
        const interval = setInterval(() => {
            const index = Math.floor(Math.random() * forms.length);
            setCurrentForm(() => forms[index]);
        }, 4000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="rounded-2xl shadow-2xl border border-gray-300 overflow-hidden">
            <CurrentForm />
        </div>
    );
};

export default FormPreview;
